import React from "react";
import { Table, Row, Col, Button } from "react-bootstrap";
import Message from "../../components/Message";
import Loader from "../../components/Loader";
import {
  useGetContactMessagesQuery,
  useDeleteMessageMutation,
  useUpdateMessageStatusMutation
} from "../../slices/contactUsSlice";
import { format } from "date-fns";
import { FaTrash, FaCheck, FaTimes, FaSync } from "react-icons/fa";
import { toast } from "react-toastify";

const ContactUsScreen = () => {
  // Use RTK Query hook instead of useSelector
  const { data: messages, isLoading, error } = useGetContactMessagesQuery();
  
  const [deleteMessage] = useDeleteMessageMutation();
  const [updateMessageStatus] = useUpdateMessageStatusMutation();

  const deleteHandler = async (id) => {
    if (window.confirm("האם אתה בטוח?")) {
      try {
        await deleteMessage(id).unwrap();
        toast.success('Message deleted successfully');
        // No need to manually refetch - RTK Query handles this automatically
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };

  const statusHandler = async (id) => {
    try {
      await updateMessageStatus(id).unwrap();
      toast.success('Message status updated');
      // No need to manually refetch - RTK Query handles this automatically
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  // Sort messages by createdAt date in descending order
  const sortedMessages = messages
    ? [...messages].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    : [];

  return (
    <>
      <Row className="align-items-center">
        <Col>
          <h1 className="text-end">פניות</h1>
        </Col>
      </Row>

      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error?.data?.message || error.error}</Message>
      ) : (
        <Table striped bordered hover responsive className="table-sm">
          <thead>
            <tr>
              <th>פעולות</th>
              <th>טופל</th>
              <th>פניה</th>
              <th>טלפון</th>
              <th>אימייל</th>
              <th>תאריך</th>
            </tr>
          </thead>
          <tbody>
            {sortedMessages && sortedMessages.length > 0 ? (
              sortedMessages.map((message) => (
                <tr key={message._id}>
                  <td>
                    <Button
                      variant="danger"
                      className="btn-sm mx-2"
                      onClick={() => deleteHandler(message._id)}
                    >
                      <FaTrash style={{ color: "white" }} />
                    </Button>
                    <Button
                      variant="success"
                      className="btn-sm"
                      onClick={() => statusHandler(message._id)}
                    >
                      <FaSync />
                    </Button>
                  </td>
                  <td>
                    {message.status ? (
                      <FaCheck style={{ color: "green" }} />
                    ) : (
                      <FaTimes style={{ color: "red" }} />
                    )}
                  </td>
                  <td style={{ maxWidth: '300px', wordWrap: 'break-word' }}>
                    {message.issue}
                  </td>
                  <td>{message.phone}</td>
                  <td>
                    <a href={`mailto:${message.email}`}>{message.email}</a>
                  </td>
                  <td>{format(new Date(message.createdAt), "dd/MM/yy HH:mm")}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  אין פניות
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default ContactUsScreen;
